<template>
  <div class="calender__items" v-bind:class="[calenderItem.loading ? 'loading' : calenderItem.typeClass]" >
    <div v-bind:class="[item, 'calender__items-item']" v-for="(item, itemIndex) in calenderItem.iconClasses" v-bind:key="itemIndex">
      <div v-bind:class="[item, 'calender__items-icon icon']"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    schedule: null
  },
  data() {
    const mappers = new Map()
    mappers.set(/\bkantoor\b/i, function (calendarItem, scheduleItem) {
      calendarItem.typeClass = 'type-office'
      if (/rotterdam/i.test(scheduleItem.location) || /rotterdam/i.test(scheduleItem.subject)) {
        calendarItem.iconClasses.push('icon-skyscraper')
      }
      else if (/middelharnis/i.test(scheduleItem.location) || /middelharnis/i.test(scheduleItem.subject)) {
        calendarItem.iconClasses.push('icon-office')
      }
      else {
        calendarItem.iconClasses.push('icon-office')
      }
    })
    mappers.set(/\bthuis/i, function (calendarItem) {
      calendarItem.typeClass = 'type-home'
      calendarItem.iconClasses.push('icon-home')
    })
    mappers.set(/\bservicedesk\b/i, function (calendarItem) {
      calendarItem.iconClasses.push('icon-servicedesk')
    })
    mappers.set(/vrije?\b|\bvakantie\b/i, function (calendarItem) {
      calendarItem.typeClass = 'type-away'
    })
    mappers.set(/Roostervrije?\b/i, function (calendarItem) {
      calendarItem.iconClasses.push('icon-rosterfree')
    })
    mappers.set(/Vakantie?\b/i, function (calendarItem) {
      calendarItem.iconClasses.push('icon-holiday')
    })
    mappers.set(/^(?!.*Rooster)Vrije?\b/i, function (calendarItem) {
      calendarItem.iconClasses.push('icon-free')
    })
    mappers.set(/\bextern\b/i, function (calendarItem) {
      calendarItem.typeClass = 'type-extern'
      calendarItem.iconClasses.push('icon-extern')
    })
    mappers.set(/\bopen(en)?\b/i, function (calendarItem) {
      calendarItem.iconClasses.push('icon-open')
    })

    return {
      mappers: mappers
    }
  },
  computed: {
    calenderItem() {
      let calendarItem = {
        typeClass: "type-default",
        iconClasses: [],
        loading: this.schedule?.loading
      }
      for (let i = 0; i < this.schedule?.scheduleItems?.length; i++) {
        this.mappers.forEach((mapper, regex) => {
          if (regex.test(this.schedule.scheduleItems[i].subject)) {
            mapper(calendarItem, this.schedule.scheduleItems[i])
          }
        })
      }
      // Remove duplicates
      calendarItem.iconClasses = Array.from(new Set(calendarItem.iconClasses));
      if (calendarItem.iconClasses.filter(item => ["icon-free", "icon-rosterfree", "icon-holiday"].includes(item)).length > 0) {
        // If it's rosterfree, free or a holiday, remove any location indicator. Servicedesk and key bearer indicator also removed as those don't make sence when out-of-office.
        calendarItem.iconClasses = calendarItem.iconClasses.filter(item => !["icon-extern", "icon-home", "icon-office", "icon-open", "icon-servicedesk", "icon-skyscraper"].includes(item))
        calendarItem.typeClass = "type-away"
        if (calendarItem.iconClasses.filter(item => item == "icon-rosterfree").length > 0) {
          // If it's roster free, also remove free and holiday.
          calendarItem.iconClasses = calendarItem.iconClasses.filter(item => !["icon-free", "icon-holiday"].includes(item))
          calendarItem.typeClass = "type-default"
        } else if (calendarItem.iconClasses.filter(item => item == "icon-holiday").length > 0) {
          // Holiday and free left? Then keep the holiday.
          calendarItem.iconClasses = calendarItem.iconClasses.filter(item => !["icon-free"].includes(item))
        }
      }
      return calendarItem
    }
  }
}
</script>


<style scoped>
.calender__items {
  border-radius: .5rem;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.calender__items-icon:not(.calender__items-item) {
  background-repeat: no-repeat;
  background-position: center center;
  display: block;
  margin: 0 .25rem;
  height: 3.2rem;
  width: 3.2rem;
  filter: drop-shadow( .3rem .3rem .2rem rgba(0,0,0,.2));
}
.type-default {
  background: linear-gradient(360deg, var(--color-brand-2nd-light) 0%, var(--color-brand-2nd) 175%);
}
.type-office,
.type-extern {
  background: linear-gradient(360deg, var(--color-brand-2nd) 0%, var(--color-brand-2nd-light) 100%);
}
.type-home {
  background: linear-gradient(360deg, var(--color-brand-1st-dark) 0%, var(--color-brand-1st) 100%);
}
.type-away {
  background: linear-gradient(360deg, rgba(76,224,126,1) 0%, rgba(76,224,126,.7) 100%);
}
.icon-home,
.icon-office,
.icon-skyscraper {
  order: -1;
}
</style>
